import * as yup from 'yup'

export const searchKeywordSchema = yup.object({
  searchKeyword: yup.string(),
  seq: yup.string(),
})
